import { defineMessages } from 'react-intl';

/**
 * Message descriptors for UploadLinks nav items. Used with $t to show localized labels.
 */
export const uploadLinksMessages = defineMessages({
  adAudios: {
    id: 'audit.filesUpload.links.adAudios',
    defaultMessage: 'Spot media',
  },
  adSchedulesPlk: {
    id: 'audit.filesUpload.links.adSchedulesPlk',
    defaultMessage: 'Spot schedules (PLK)',
  },
  adSchedulesAsc: {
    id: 'audit.filesUpload.links.adSchedulesAsc',
    defaultMessage: 'Spot schedules (ASC)',
  },
  liveMentionSchedulesCsv: {
    id: 'audit.filesUpload.links.liveMentionSchedulesCsv',
    defaultMessage: 'Mention schedules (CSV)',
  },
  bcrUpload: {
    id: 'audit.filesUpload.links.bcrUpload',
    defaultMessage: 'BCR upload',
  },
  ltxUpload: {
    id: 'audit.filesUpload.links.ltxUpload',
    defaultMessage: 'LTX upload',
  },
  avgUpload: {
    id: 'audit.filesUpload.links.avgUpload',
    defaultMessage: 'AVG upload',
  },
});
